import Icon from '../components/Icon.vue'

Icon.register({
  'caret-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M288.7 352H31.3C13.5 352 4.6 330.5 17.2 317.9L145.9 189.2C153.7 181.4 166.3 181.4 174.1 189.2L302.8 317.9C315.4 330.5 306.5 352 288.7 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-up.js
// module id = GUCf
// module chunks = 144